import DatePicker, {registerLocale} from "react-datepicker";
import de from "date-fns/locale/de";
import "react-datepicker/dist/react-datepicker.css";
import "./BBDatePicker.css"
import { addDays, getDay } from "date-fns"
import { useState,useEffect } from "react";
import { formatDate } from "./util";
registerLocale("de",de);

export default function BBDatePicker(props) {
  const [buchungsData,setBuchungsData] = useState({
    isLoaded:false, 
    data:[],
    error:null,
  });




  const [errormsg,setErrormsg] = useState();
  const state = props.state;
  const setState = props.setState;
  const standortState = props.standortState;
  const serviceState = props.serviceState;
  

  useEffect(() => {
    const storedDate = sessionStorage.getItem("selectedDate");
    if (storedDate) {
      props.onChange(new Date(storedDate));
    }
  }, []);
  
  //disables the whole picker if service or standort isnt set
  function checkDisabled(){
    console.log(standortState);
    console.log(serviceState);
     return !(typeof standortState.default_arbeitseinh !== 'undefined' && standortState.default_arbeitseinh &&typeof serviceState.arbeitseinheiten !== 'undefined' && serviceState.arbeitseinheiten >0);
  }

  //disables date if date is already booked out.
  function dateIsFull(date){
    const myMap = buchungsData.data;
    const available_time = standortState.default_arbeitseinh;
    const selectedDate = date.toISOString().split('T')[0];

    if(myMap.get(selectedDate)){
      console.log(selectedDate +" " + (myMap.get(selectedDate) + serviceState.arbeitseinheiten > available_time));
    }
    return (myMap.get(selectedDate) && (myMap.get(selectedDate)+serviceState.arbeitseinheiten) > available_time);
  }

  function getStandortBuchungen(standort) {
    if (typeof standort === 'undefined' || !standort) {
      return;
    }
  
    const baseUrl = process.env.REACT_APP_API_URL;
  
    let query = `items/standort/${standort}?deep={"buchungen":{"_filter":{"datum": {"_gt": "$NOW"}}}}&fields=buchungen.datum,buchungen.service.arbeitseinheiten,buchungen.id`;
  
    fetch(`${baseUrl}/${query}`)
      .then(res => res.json())
      .then(
        (result) => {
          console.log(result);
          setBuchungsData({ isLoaded: true, data: calcAuslastung(result.data.buchungen) });
        }, (error) => {
          setBuchungsData({ isLoaded: true, error });
        }
      )
  }
  
  const isWeekday = (date) => {
    const day = getDay(date);
    return day !== 0 && day !== 6; //&& !dateIsFull(date);
  };

  useEffect(() => {
    getStandortBuchungen(standortState.name);
  }, [standortState])

  const {error, isLoaded, data} = buchungsData;
  const renderBuchungen =() =>{
    if(error){
      return <div>Error: {error.message}</div>
    }else if(!isLoaded){
      return<div>Loading...</div>
    }else{
     return(<ul>
        {Array.from(data).map(([mkey,mval] )=> (
        <li key={mkey}>{mkey} {mval}</li>
        ))}
        </ul>);
    }
  }
  const calcAuslastung =(buchungen)=>{
    const myMap = new Map();
    for(let buchung of buchungen){
      let datum = new Date(buchung.datum.replace(/-/g, '\/')).toISOString().split('T')[0];
      let entry = myMap.get(datum);
      if(entry){
        myMap.set(datum,entry+buchung.service.arbeitseinheiten);
      }else{
        myMap.set(datum,buchung.service.arbeitseinheiten);
      }
    }
    console.log(myMap);
    return myMap;
  }

  return (<>
    <DatePicker selected={props.state} 
      onChange={(date) => {
        date = formatDate(date);
        // console.log("AAAAAAAA date",date);
        sessionStorage.setItem("selectedDate", date.toISOString());
        props.setState(date);
        props.onChange(date);
      }}
      //disabled={checkDisabled()}
      locale="de"
      filterDate={isWeekday} 
      placeholderText={"Datum wählen"}
      minDate={addDays(new Date(), 1)}
      dateFormat="dd/MM/yyyy"
      inline
      ></DatePicker>
      
  </>
  );
}